// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Jjah","left":"StickyBox_left__CEhVM","right":"StickyBox_right__2xnT3"};